import { render } from "./LessonToggle2.vue?vue&type=template&id=72eed102&scoped=true"
import script from "./LessonToggle2.vue?vue&type=script&lang=js"
export * from "./LessonToggle2.vue?vue&type=script&lang=js"

import "./LessonToggle2.vue?vue&type=style&index=0&id=72eed102&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72eed102"]])

export default __exports__